import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../Services/crud.service";
import { LogedInUserService } from "../../Services/loged-in-user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentPlansActions } from "src/app/ThemeOptions/store/payment-plans.actions";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { FormStateService } from "src/app/Services/form.service";
import { TranslateModule } from "@ngx-translate/core";
import {
  ReactiveFormsModule,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { RecaptchaService } from "../../Services/recaptcha.service";

declare var Razorpay: any;

@Component({
  selector: "app-login-boxed",
  templateUrl: "./login-boxed.component.html",
  styles: [``],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, RouterModule],
})
export class LoginBoxedComponent implements OnInit {
  emailId = "";
  password = "";
  registerForm: UntypedFormGroup;
  submitted = false;

  site_key = environment.recaptcha.siteKey;
  captchaToken = "";
  userData: any;
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private router: Router,
    private logedInUserService: LogedInUserService,
    private store: Store<{ config: any }>,
    private paymentPlansActions: PaymentPlansActions,
    private route: ActivatedRoute,
    private formStateService: FormStateService,
    private recaptcha: RecaptchaService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/
          ),
        ],
      ],
    });
    this.registerForm.valueChanges.subscribe(() => {
      if (this.registerForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    const currentRoute = this.route.snapshot.routeConfig.path;

    // Set default values if demo
    if (currentRoute === "demo") {
      this.registerForm.patchValue({
        email: "user@demo.com",
        password: "80B6srQxMJ@",
      });
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  createLicense(licenseHistoryEntry) {
    this.crudService.post(
      licenseHistoryEntry,
      (response) => {
        this.paymentPlansActions.selectPlan(null);
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          this.toastr.error(response.error.error.message, "Invalid Operation");
          this.router.navigate(["/page/project-license-information"]);
        } else {
          this.toastr.success("License Purchased", "Success");
          this.router.navigate(["/page/project-license-information"]);
        }
      },
      "licenseHistories"
    );
  }

  createLicenseHistoryEntry(userData, selectedPlan) {
    var licenseHistoryEntry = {
      licenseModuleId: selectedPlan.id,
      transactionId: null,
      orderId: null,
      razor_pay_response: null,
    };
    var amount = parseFloat(selectedPlan.totalAmount);
    if (isNaN(amount)) {
      console.error("The applicableAmount is not a valid number.");
      amount = 0;
    } else {
      amount = Math.round(amount * 100);
    }
    if (selectedPlan.paymentFrequency != "free") {
      this.crudService.post(
        { amount: amount },
        (order) => {
          if (!order.error) {
            const RazorpayOptions = {
              description:
                "TheAppSherpa" +
                " " +
                selectedPlan.paymentFrequency +
                " " +
                "plan payment.",
              currency: "USD",
              amount: amount,
              name: "TheAppSherpa",
              key: "rzp_live_PkhJ3SFfKZ4yqf",
              image: `${environment.appURL}/assets/images/appsherpa-icon-blue.png`,
              theme: {
                color: "#032d55",
              },
              modal: {
                ondismiss: () => {
                  console.log("Payment modal dismissed");
                },
              },
              handler: (response: any) => {
                licenseHistoryEntry.razor_pay_response = response;
                licenseHistoryEntry.transactionId =
                  response.razorpay_payment_id;
                licenseHistoryEntry.orderId = order.id;
                this.createLicense(licenseHistoryEntry);
              },
            };

            const razorpay = new Razorpay(RazorpayOptions);
            razorpay.open();

            razorpay.on("payment.failed", (response: any) => {
              console.error(response.error);
            });
          }
        },
        "licenseHistories/createOrder"
      );
    } else {
      this.createLicense(licenseHistoryEntry);
    }
  }

  onSubmit() {
    var self = this;
    this.submitted = true;

    // console.log("on submit called");
    // stop here if form is invalid
    if (this.registerForm.invalid) return;

    var payload = this.registerForm.value;

    payload.email = payload.email.toLowerCase();
    this.recaptcha
      .executeAction("login")
      .then((token) => {
        // Verify token (optional: only if you have backend verification)
        this.recaptcha
          .verifyToken(token, "login", payload)
          .subscribe((response) => {
            console.log("response from login", response);
            if (
              response.result &&
              response.result.message &&
              response.result.message == "verified"
            ) {
              self.crudService.post(
                payload,
                function (response) {
                  self.formStateService.clearFormDirty();
                  if (response && response.user) {
                    if (response.user.status === true) {
                      localStorage.setItem("access_token", response.id);
                      localStorage.setItem("userId", response.userId);

                      const assignedRoles = response.user.roleId.map(
                        (key) => roles[key]
                      );
                      localStorage.setItem("roles", assignedRoles);
                      self.logedInUserService.set(response.user);

                      self.store
                        .select((state) => state.config)
                        .pipe(take(1))
                        .subscribe((selectedPlan) => {
                          if (selectedPlan) {
                            self.createLicenseHistoryEntry(
                              response.user,
                              selectedPlan
                            );
                          } else {
                            self.router.navigate(["/page/dashboard"]);
                          }
                        });
                    } else {
                      self.toastr.error("Invalid Credentials");
                    }
                  } else {
                    if (
                      response.error?.error?.message &&
                      response.error.error.message !== "login failed"
                    ) {
                      self.toastr.error(
                        response.error.error.message,
                        "Invalid Operation"
                      );
                    } else {
                      self.toastr.error(
                        "Invalid email or password.",
                        "Invalid Operation"
                      );
                    }
                  }
                },
                "userManagements/login?include=user"
              );
            } else if (
              response.result &&
              response.result.message &&
              response.result.message == "bot-like-behavior"
            ) {
              self.toastr.error(
                "Please try again later or use a different browser."
              );
            } else {
              self.toastr.error("reCAPTCHA failed. Please try again.");
            }
          });
      })
      .catch((err) => {
        console.error("reCAPTCHA error:", err);
        self.toastr.error("reCAPTCHA validation error. Try again later.");
      });

    if (
      (globalThis as any).TASClient &&
      typeof (globalThis as any).TASClient.addRolesFromClient === "function"
    ) {
      // if(userInfo)
      let rolesArray = localStorage
        .getItem("roles")
        .split(",")
        .map((role) => role.trim());

      (globalThis as any).TASClient.addRolesFromClient(
        localStorage.getItem("userId"),
        rolesArray
      )
        .then(() => {
          console.log("adding roles : success");
        })
        .catch((error) => {
          console.error("adding roles : failed", error);
        });
    } else {
      console.log("UFOClient is not accessible or not a function");
    }
  }
}

var roles = {
  "66260511cbc06e1b61aac411": "Writer",
  "66260532cbc06e1b61aac412": "Reviewer",
  "66260546cbc06e1b61aac413": "Publisher",
  "66260555cbc06e1b61aac414": "Administrator",
  "6644b416d890eebfe93113e4": "readonly",
  "66615cc0d4715f5c2da5e4d0": "SuperAdministrator",
};
/*  .btn-link {
        color: #032d55;
        background-color: transparent;
        text-decoration: none !important;
      }

      .btn-link:hover {
        background-color: transparent !important;
        text-decoration: underline !important;
        color: inherit !important;
        box-shadow: none !important; 
      } */
